module.exports = __webpack_public_path__ + "static/media/pardo.0eb948e8.svg";